/**
 * Pattern class name
 */
/* istanbul ignore next - That can be used in sails, standalone or other context to select an video pattern */
export var VIDEO_BASE_CLASSNAME = 'ws10-video';
